module.exports = __webpack_public_path__ + "img/capacio-log-black.0d2a4a60.png";